
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../../modules/Auth/_redux/authRedux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

import * as crud from "./operations";
import * as _region from "../CatalogRegions/operations"

import { ClienDeleteModal, PreviewModal } from "./editModal";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import overlayFactory from 'react-bootstrap-table2-overlay';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { filterFactory, optionsFactory, FilterLayout } from "../../helper/table"
import ExcelExport from "../../helper/export-xlsx"
import PDFExport from "../../helper/export-pdf"
import { useToasts } from 'react-toast-notifications';
import * as _enter from "../CatalogClients/operations"
import { useSelector } from "react-redux";

const { ExportCSVButton } = CSVExport;
function Wrapper(props) {
  const { user } = useSelector(state => state.auth);
  const userDocument = user.uid ? user : user.payload
  const { addToast } = useToasts()
  const [queryng, setQuery] = useState(true)
  const [regionList, setRegions] = useState([]);
  const [documents, setDcouments] = useState([]);
  const [states, setStates] = useState([])
  const [edit_show, setEditShow] = useState(false);
  const [preview_show, setPreviewShow] = useState(false);
  const [delete_show, setDeleteShow] = useState(false);
  const [filter, setFilter] = useState("");
  const [activeClient, setActiveClient] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      const [
        region_query,
        documents_query,
        enterprise_query
      ] = await Promise.all([
        _region.getClient(""),
        crud.getClient(""),
        _enter.getClient(userDocument.company_id)

      ])

      const enterprise = enterprise_query.data.payload

      const states = enterprise.states ?? []

      const _locations = documents_query.data.payload
      const locations = _locations.filter(l => states.includes(l.state))
      const regions = region_query.data.payload
      const regionsHash = regions.reduce((hash, row) => ({ ...hash, [row.uid]: row }), {})
      const _docs = locations.sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      }).map(doc => {
        const region = regionsHash[doc.region] ?? {}
        return {
          ...doc,
          region: region.name
        }
      })
      setStates(states)
      setRegions(regions)
      setDcouments(_docs);
      setQuery(false);
    }
    fetchData()
  }, [userDocument.company_id]);

  const controllers = {
    states: states,
    regionList: regionList,
    controllers: props.controllers,
    show: edit_show,
    pos: documents,
    preview: preview_show,
    delete: delete_show,
    client: activeClient,
    handleClose: () => setEditShow(false),
    handleShow: () => setEditShow(true),
    hideDelete: () => setDeleteShow(!delete_show),
    togglePreview: () => setPreviewShow(!preview_show),
    handleDelete: (uid) => {
      crud
        .getClient(uid)
        .then((res) => {
          const client = res.data.payload;
          setActiveClient(client);
          setDeleteShow(true);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteClient: (uid) => {
      crud.deleteClient(uid).then(() => {
        crud.getClients(setDcouments);
        addToast(process.env["REACT_APP_DELETE"], { appearance: 'success' });


        setDeleteShow(!delete_show);
      }).catch(err => {
        addToast(process.env["REACT_APP_NO_DELETE"], { appearance: 'error' });
      })
    },
    update: (client) => {
      crud.updateClient(client).then(() => {
        crud.getClients(setDcouments);
        addToast(process.env[`REACT_APP_${(client.uid ? "update" : "create").toUpperCase()}`], { appearance: 'success' });

        setEditShow(!edit_show);
      }).catch(err => {
        addToast(process.env[`REACT_APP_${(client.uid ? "no_update" : "no_create").toUpperCase()}`], { appearance: 'error' });


      })
    },
    openEdit: (uid) => {
      if (uid) {
        crud
          .getClient(uid)
          .then((res) => {
            const client = res.data.payload;
            setActiveClient(client);
            setEditShow(!edit_show);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        setActiveClient({});
        setEditShow(!edit_show);
      }
    },
  };

  if (!crud.columns.filter((col) => col.dataField === "region").length) {
    crud.columns.push({
      dataField: "region",
      text: "Region",
      sort: true,
    });
    crud.columns.push({
      dataField: "contact",
      text: "Contact",
      sort: true,
    })
    crud.columns.push({
      dataField: "phone",
      text: "Contact Number",
      sort: true,
    })

  }
  const fields = ["name", "description", "contact", "phone", "address", "state", "city", "zipcode"]
  const data = filterFactory(documents, filter, fields)
  const options = optionsFactory(data)
  return (
    <ToolkitProvider
      keyField="uid"
      data={data.map((doc, i) => ({ no: Number(i) + 1, ...doc }))}
      columns={crud.columns}
      exportCSV={true}
    >
      {
        toolkit => (
          <>
            <div
              className="content d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div className="card card-custom gutter-b">
                <div className="card-header d-flex justify-content-between">
                  <h5 className="mt-7 card-label">POS</h5>

                  <div className="card-toolbar">
                    <div className="card mx-2">
                      <div className="card-toolbar">

                        <span className="svg-icon svg-icon-md  mx-2">
                          <SVG
                            src={toAbsoluteUrl("/media/svg/icons/Files/Export.svg")}
                          />
                        </span>
                        <ExportCSVButton
                          {...toolkit.csvProps}
                          className="btn btn-info font-weight-bolder mx-1"
                        >
                          .CSV
                    </ExportCSVButton>
                        <PDFExport columns={fields} data={data} name="pos">
                          <button className="btn btn-danger font-weight-bolder mx-1">
                            .PDF
                          </button>
                        </PDFExport>
                        <ExcelExport columns={fields} data={data} name="pos">
                          <div className="btn btn-success font-weight-bolder mx-2">
                            .XLS
                          </div>
                        </ExcelExport>
                      </div>
                    </div>
                    <div
                      /* href="#" */
                      className="btn btn-secondary font-weight-bolder mx-2"
                      onClick={() => {
                        controllers.togglePreview();
                      }}
                    >
                      <span className="svg-icon svg-icon-md">
                        <SVG
                          src={toAbsoluteUrl("/media/svg/icons/Map/Compass.svg")}
                        />
                      </span>
                      View in Map
                    </div>


                  </div>
                </div>

                <div className="card-body">
                  <FilterLayout controller={setFilter} />
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    bordered={false}
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    keyField="uid"
                    {...toolkit.baseProps}
                    loading={queryng}
                    pagination={paginationFactory(options)}
                    overlay={overlayFactory({ spinner: true })}
                    noDataIndication={<div className="mr-2 text-muted">No records found</div>}
                  ></BootstrapTable>
                </div>
              </div>
            </div>
            <ClienDeleteModal {...controllers} />
            <PreviewModal {...controllers} />

          </>
        )
      }
    </ToolkitProvider >
  );
}
export default injectIntl(connect(null, auth.actions)(Wrapper));